import React, { Component } from 'react';
import {
  Auth
} from 'aws-amplify';
import Button from '@material-ui/core/Button';

export default class SignOutButton extends Component {
  state = {
    authState: '',
  };

  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  checkUser = () => {
    const {
      authState
    } = this.state;

    return Auth.currentAuthenticatedUser()
      .then(() => {
        if (!this._isMounted) { return; }
        if (authState !== 'signedIn') {
          this.setState({
            authState: 'signedIn'
          });
        }
      })
      .catch(() => {
        if (!this._isMounted) { return; }
        if (!authState || authState === 'signedIn') {
          this.setState({
            authState: 'signIn'
          });
        }
      })
    ;
  };

  signOut = () => {
    Auth.signOut()
      .then(() => {
        window.location.reload();
      })
      .catch(error => {
        console.error(error);
      })
    ;
  };

  render() {
    const {
      authState
    } = this.state;
    const signedIn = (authState === 'signedIn');

    if (!signedIn) {
      return null;
    }

    return (
      <Button
        color="inherit"
        onClick={this.signOut}
      >
        Logout
      </Button>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Authentication/SignOutButton.js